import { Typography } from 'antd';
import { camelCase } from 'lodash';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';
import { StatusFieldOption } from 'api/tasks';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { STATUS_FIELD_NAME } from 'data/fields/hooks';
import { CellRendererParams } from './types';

const { Paragraph: AntParagraph } = Typography;
const SingleLineLabel = styled(AntParagraph).attrs({
  ellipsis: { rows: 1, tooltip: true },
})`
  margin-bottom: 0;
  color: inherit;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  gap: var(--spacing-04);
  padding-right: var(--spacing-03);
`;

export const TaskNameRenderer: FC<CellRendererParams> = ({ data }) => {
  const status = useMemo(
    () =>
      data.fields?.find(
        (f) => camelCase(f.fieldName) === camelCase(STATUS_FIELD_NAME),
      )?.metaFieldValue,
    [data.fields],
  );

  return status != null ? (
    <Wrapper>
      <StatusIndicator status={status as StatusFieldOption} />
      <SingleLineLabel>{data.taskName}</SingleLineLabel>
    </Wrapper>
  ) : (
    <></>
  );
};
